/** Appends `/work` to a profile URL, preserving any querystring. */
export function appendWorkSubpath(href: string): string {
	if (!href) {
		return href;
	}
	const [pathPart, queryPart] = href.split('?');
	const normalisedPath = pathPart.endsWith('/') ? `${pathPart}work` : `${pathPart}/work`;
	return queryPart === undefined ? normalisedPath : `${normalisedPath}?${queryPart}`;
}
